import { type FC, useContext } from "react"
import { ModalContext } from "@/components/ui/Modal"
import { Button } from "@/ui/Button/Button"
import { ButtonGroup } from "@/ui/Button/StyledButton"

type ButtonsProps = {
  onOk: () => void
  onCancel?: () => void
}

export const Buttons: FC<ButtonsProps> = ({ onOk, onCancel }) => {
  const modalContext = useContext(ModalContext)

  return (
    <ButtonGroup>
      <Button
        type={"button"}
        variant={"link"}
        size={"large"}
        onClick={(e) => {
          e.preventDefault()

          onOk()

          modalContext?.hide()
        }}
      >
        Да, очистить
      </Button>
      <Button
        type={"button"}
        variant={"filled"}
        size={"large"}
        onClick={(e) => {
          e.preventDefault()

          if (typeof onCancel === "function") {
            onCancel()
          }

          modalContext?.hide()
        }}
      >
        Нет, оставить
      </Button>
    </ButtonGroup>
  )
}
